import React, { Component } from 'react';
import ConstElement from '../common/ConstElement';
import AvatarEditor from '../../modules/react-avatar-editor/';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      client: {
        identification_img_file_crop: '',
        profile_img_file_crop: '',
        identification_img_file_back_crop: '',
        identification_img_file_back2_crop: '',
        date_interview: null,
        birthday: null,
      },
      cities: [],
      prefs: [],
      imgIdentification: {
        img: '',
        name: '',
        width: 0,
        height: 0,
      },
      imgProfile: {
        img: '',
        name: '',
        width: 0,
        height: 0,
      },
      imgIdentificationFileBack: {
        img: '',
        name: '',
        width: 0,
        height: 0,
      },
      imgIdentificationFileBack2: {
        img: '',
        name: '',
        width: 0,
        height: 0,
      },
      reach_from_types: [
          {
            value:1,
            text: "Google",
          },
          {
            value: 2,
            text: "Yahoo",
          },
          {
            value: 12,
            text: "インディード",
          },
          {
            value: 13,
            text: "ワーキン",
          },
          {
            value: 15,
            text: "engage",
          },
          {
            value: 3,
            text: "その他webサイト",
          },
          {
            value: 4,
            text: "Twitter",
          },
          {
            value: 5,
            text: "Instagram",
          },
          {
            value: 6,
            text: "Facebook",
          },
          {
            value: 7,
            text: "テレビ",
          },
          {
            value: 8,
            text: "新聞記事",
          },
          {
            value: 9,
            text: "雑誌",
          },
          {
            value: 14,
            text: "チラシ",
          },
          {
            value: 10,
            text: "紹介",
          },
          {
            value: 16,
            text: "農業Week",
          },
          {
            value: 11,
            text: "エントリースタッフ",
          },
          {
            value: 99,
            text: "その他",
          },
          {
            value: null,
            text: "未回答",
          },
      ],
    };
    axios.get('/api/config/get/img_profile_img_file').then((response) => {
      this.setState({
        imgProfile: {
          img: '',
          name: '',
          width: response.data.width,
          height: response.data.heigh,
        },
      });
    });

    axios
      .get('/api/config/get/img_identification_img_file')
      .then((response) => {
        this.setState({
          imgIdentification: {
            img: '',
            name: '',
            width: response.data.width,
            height: response.data.heigh,
          },
        });
      });
    axios
      .get('/api/config/get/img_identification_img_file_back')
      .then((response) => {
        this.setState({
          imgIdentificationFileBack: {
            img: '',
            name: '',
            width: response.data.width,
            height: response.data.heigh,
          },
        });
      });
    axios
      .get('/api/config/get/img_identification_img_file_back2')
      .then((response) => {
        this.setState({
          imgIdentificationFileBack2: {
            img: '',
            name: '',
            width: response.data.width,
            height: response.data.heigh,
          },
        });
      });
    this.getAccountById = this.getAccountById.bind(this);
    this.saveData = this.saveData.bind(this);
    this.setData = this.setData.bind(this);
    this.getData = this.getData.bind(this);
    this.handleInptChange = this.handleInptChange.bind(this);
    this.renderHoujinStatus = this.renderHoujinStatus.bind(this);
    this.handlePreviewImg = this.handlePreviewImg.bind(this);
    this.cropImageIdentification = this.cropImageIdentification.bind(this);
    this.cropImageIdentificationFileBack = this.cropImageIdentificationFileBack.bind(
      this
    );
    this.cropImageIdentificationFileBack2 = this.cropImageIdentificationFileBack2.bind(
      this
    );
    this.handleChangeEditDateInterview = this.handleChangeEditDateInterview.bind(
      this
    );
    this.handleChangeBirthday = this.handleChangeBirthday.bind(this);
    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
    this.deleteAccount = this.deleteAccount.bind(this);
    this.updateStatusRecoverAccount = this.updateStatusRecoverAccount.bind(
      this
    );
  }

  /**
   * Process change date interview
   */
  handleChangeEditDateInterview(date) {
    let clientData = Object.assign({}, this.state.client);
    clientData['date_interview'] = date;
    this.setState({ client: clientData });
  }

  /**
   * Process change birthday
   */
  handleChangeBirthday(date) {
    let clientData = Object.assign({}, this.state.client);
    clientData['birthday'] = date;
    this.setState({ client: clientData });
  }

  /**
   * Process change start_date
   */
  handleChangeStartDate(date) {
    let clientData = Object.assign({}, this.state.client);
    clientData['start_date'] = date;
    this.setState({ client: clientData });
  }

  /**
   * Init data
   */
  componentWillMount() {
    axios.get('/api/cities').then((response) => {
      this.setState({
        cities: response.data,
      });
    });
    axios.get('/api/prefs').then((response) => {
      this.setState({
        prefs: response.data,
      });
    });
    this.getAccountById();
  }

  getAccountById() {
    if (this.props.match.params.hasOwnProperty('id')) {
      const clientId = this.props.match.params.id;
      axios
        .get('/api/accounts/' + clientId)
        .then((response) => {
          response.data.password = '';
          response.data.password_confirmation = '';
          let clientData = Object.assign({}, this.state.client);
          clientData = response.data;
          this.setState({ client: clientData });
        })
        .catch(() => {
          this.props.history.push('/_404');
        });
    }
  }

  /**
   * Set data of client
   * data: Object Client
   */
  setData(data) {
    this.setState({
      client: data,
    });
  }

  /**
   * Get data of client
   */
  getData() {
    return this.state.client;
  }

  /**
   * Listen change input
   * event: Object input
   */
  handleInptChange(event) {
    let clientData = Object.assign({}, this.state.client);
    if (event.target.name === 'company_pref') {
      clientData['company_city'] = '';
    }
    if (event.target.name === 'pref') {
      clientData['city'] = '';
    }
    clientData[event.target.name] = event.target.value;
    this.setState({ client: clientData });
  }

  /**
   * Update status
   */
  updateStatus(e) {
    this.setState({ processing: true });
    let client = this.getData();
    let status = e.currentTarget.getAttribute('status');
    if (status == 1) {
      if (client.is_houjin) {
        client.houjin_status = status;
        this.saveData(true);
        return;
      }
      let system_fee_per = this.state.client.system_fee_per;
      if (!system_fee_per || !isFinite(system_fee_per)) {
        alert('システム利用料を入力してください。');
        this.setState({ processing: false });
        return;
      }
      let system_fee_per_num = system_fee_per - 0;
      if (system_fee_per_num < 0 || system_fee_per_num >= 100) {
        alert('システム利用料は100以下の数値を入力してください。');
        this.setState({ processing: false });
        return;
      }
    }
    let textStatus = this.processStatus(status);
    let msgAlert = 'この依頼者を承認してよろしいですか？';
    client.status = status;
    if (status == 8) {
      msgAlert = 'このアカウントを停止してもよろしいですか？';
    }
    if (status == 9) {
      msgAlert = 'この依頼者を非承認にしてよろしいですか？';
    }
    if (window.confirm(msgAlert)) {
      //to top
      window.scrollTo(0, 0);
      axios
        .post('/api/accounts/update-status/' + client.id, client)
        .then((response) => {
          this.setState({ processing: false });
          if (
            response.data.hasOwnProperty('success') &&
            response.data.success
          ) {
            this.getAccountById();
            toast.success(response.data.message);
            let clientData = Object.assign({}, this.state.client);
            clientData['status'] = status;
            this.setState({ client: clientData });
            $('.cls-status').val(textStatus);
          } else {
            Object.keys(response.data.errors).map((key, i) => {
              if ($.isArray(response.data.errors[key])) {
                response.data.errors[key].map((child, i) => {
                  toast.error(child);
                });
              } else {
                toast.error(response.data.errors[key]);
              }
            });
          }
        })
        .catch((error) => {
          this.setState({ processing: false });
          Object.keys(error.response.data.errors).map((key, i) => {
            if ($.isArray(error.response.data.errors[key])) {
              error.response.data.errors[key].map((child, i) => {
                toast.error(child);
              });
            } else {
              toast.error(error.response.data.errors[key]);
            }
          });
        });
    }
  }

  /**
   * Delete account
   */
  deleteAccount() {
    this.setState({ processing: true });
    let client = this.getData();
    if (window.confirm('このアカウントを削除してもよろしいですか？')) {
      //to top
      window.scrollTo(0, 0);
      axios
        .post('/api/accounts/delete-account/' + client.id, client)
        .then((response) => {
          this.setState({ processing: false });
          if (
            response.data.hasOwnProperty('success') &&
            response.data.success
          ) {
            toast.success(response.data.message);
            this.props.history.push('/accounts');
          } else {
            Object.keys(response.data.errors).map((key, i) => {
              if ($.isArray(response.data.errors[key])) {
                response.data.errors[key].map((child, i) => {
                  toast.error(child);
                });
              } else {
                toast.error(response.data.errors[key]);
              }
            });
          }
        })
        .catch((error) => {
          this.setState({ processing: false });
          Object.keys(error.response.data.errors).map((key, i) => {
            if ($.isArray(error.response.data.errors[key])) {
              error.response.data.errors[key].map((child, i) => {
                toast.error(child);
              });
            } else {
              toast.error(error.response.data.errors[key]);
            }
          });
        });
    }
  }

  /**
   * Update status recover account
   */
  updateStatusRecoverAccount(e) {
    this.setState({ processing: true });
    let client = this.getData();
    let status = e.currentTarget.getAttribute('status');
    let textStatus = this.processStatus(status);
    let msgAlert = 'このアカウントを復旧してもよろしいですか？';
    client.status = status;
    if (window.confirm(msgAlert)) {
      //to top
      window.scrollTo(0, 0);
      axios
        .post(
          '/api/accounts/update-status-recover-account/' + client.id,
          client
        )
        .then((response) => {
          this.setState({ processing: false });
          if (
            response.data.hasOwnProperty('success') &&
            response.data.success
          ) {
            this.getAccountById();
            toast.success(response.data.message);
            let clientData = Object.assign({}, this.state.client);
            clientData['status'] = status;
            this.setState({ client: clientData });
            $('.cls-status').val(textStatus);
          } else {
            Object.keys(response.data.errors).map((key, i) => {
              if ($.isArray(response.data.errors[key])) {
                response.data.errors[key].map((child, i) => {
                  toast.error(child);
                });
              } else {
                toast.error(response.data.errors[key]);
              }
            });
          }
        })
        .catch((error) => {
          this.setState({ processing: false });
          Object.keys(error.response.data.errors).map((key, i) => {
            if ($.isArray(error.response.data.errors[key])) {
              error.response.data.errors[key].map((child, i) => {
                toast.error(child);
              });
            } else {
              toast.error(error.response.data.errors[key]);
            }
          });
        });
    }
  }

  /**
   * Handle show image original
   */
  showImgOriginal(e) {
    var urlImage = e.currentTarget.getAttribute('url');
    var showImg = window.open('', '_blank');
    if (showImg) {
      axios.get(urlImage).then((response) => {
        var image = new Image();
        image.src = response.data;
        showImg.document.write(image.outerHTML);
      });
    }
  }

  /**
   * Handle show text of status
   */
  processStatus(status) {
    switch (parseInt(status)) {
      case 0:
        return '未承認';
      case 1:
        return '承認';
      case 8:
        return '停止';
      case 9:
        return '否認';
      default:
        return '選択してください';
    }
  }

  /**
   * Load and show image
   * input: Object input
   * idImg: String id of img
   */
  readURL(input, idImg) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      let clientData = Object.assign({}, this.state.client);
      let imgIden = Object.assign({}, this.state.imgIdentification);
      let imgIdenFileBack = Object.assign(
        {},
        this.state.imgIdentificationFileBack
      );
      let imgIdenFileBack2 = Object.assign(
        {},
        this.state.imgIdentificationFileBack2
      );
      reader.onload = (e) => {
        //Save origin img.
        clientData[input.name] = e.target.result;
        this.setState({ client: clientData });
        if (input.name == 'identification_img_file') {
          //Set config for avatareditor
          imgIden['img'] = clientData[input.name];
          imgIden['name'] = input.name;
          this.setState({ imgIdentification: imgIden });
          //this.cropImage();
          $('#img-identification_img_file').hide();
          $('#identificationCanvas').show();
          $('#btn-crop-image-file').addClass('cls-is-showing');
        } else if (input.name == 'identification_img_file_back') {
          //Set config for avatareditor
          imgIdenFileBack['img'] = clientData[input.name];
          imgIdenFileBack['name'] = input.name;
          this.setState({ imgIdentificationFileBack: imgIdenFileBack });
          //this.cropImage();
          $('#img-identification_img_file_back').hide();
          $('#identificationFileBackCanvas').show();
          $('#btn-crop-image-file-back').addClass('cls-is-showing');
        } else if (input.name == 'identification_img_file_back2') {
          //Set config for avatareditor
          imgIdenFileBack2['img'] = clientData[input.name];
          imgIdenFileBack2['name'] = input.name;
          this.setState({ imgIdentificationFileBack2: imgIdenFileBack2 });
          //this.cropImage();
          $('#img-identification_img_file_back2').hide();
          $('#identificationFileBack2Canvas').show();
          $('#btn-crop-image-file-back2').addClass('cls-is-showing');
        } else {
          //Call resize image
          this.reizeImage(
            e.target.result,
            this.state.imgProfile.width,
            this.state.imgProfile.height,
            'img-profile_img_file'
          );
        }
      };
      reader.readAsDataURL(input.files[0]);
    }
  }

  /**
   * Resize image
   */
  resizeImage(data, MAX_WIDTH, MAX_HEIGHT, idName) {
    var img = new Image();
    img.onload = () => {
      width = this.width;
      height = this.height;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      var width = img.width;
      var height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      var dataurl = canvas.toDataURL('image/png');
      document.getElementById(idName).src = dataurl;
      let clientData = Object.assign({}, this.state.client);
      clientData['profile_img_file' + '_crop'] = dataurl;
      this.setState({ client: clientData });
    };
    img.src = data;
  }

  /**
   * Show image
   */
  handlePreviewImg(event) {
    if (event.currentTarget.files[0].size > 10485760) {
      alert('10MB以下の画像をアップロードしてください');
      document.getElementById(event.currentTarget.getAttribute('id')).value =
        '';
    } else {
      this.readURL(event.target, 'img-' + event.target.name);
    }
  }

  /**
   * Call function save data from element parent
   */
  saveData(actionFromApproveBtn = false) {
    this.setState({ processing: true });
    let client = this.getData();
    if (
      $('#btn-crop-image-file').hasClass('cls-is-showing') ||
      $('#btn-crop-image-file-back').hasClass('cls-is-showing') ||
      $('#btn-crop-image-file-back2').hasClass('cls-is-showing')
    ) {
      alert('画像をアップロードした後はクロップボタンを押してください。');
      window.scrollTo(0, 0);
      return false;
    }
    if (client.password == null || client.password == '') {
      delete client.password;
      delete client.password_confirmation;
    }
    if (client.is_houjin) {
      client.status = client.houjin_status;
    }
    //to top
    window.scrollTo(0, 0);
    if (client.hasOwnProperty('id')) {
      if (client.tel) {
        this.checkUniqueTel(actionFromApproveBtn, client);
      } else {
        this.updateAccount(actionFromApproveBtn, client);
      }
    }
  }

  checkUniqueTel(actionFromApproveBtn, client) {
    axios
      .post('/api/accounts/check_unique_tel/' + client.id, client)
      .then((response) => {
        this.setState({ processing: false });
        if (response.data.count) {
          if (window.confirm('重複する電話番号が存在します\n保存しますか？')) {
            this.updateAccount(actionFromApproveBtn, client);
          } else {
            return false;
          }
        } else {
          this.updateAccount(actionFromApproveBtn, client);
        }
      })
      .catch((error) => {
        if (actionFromApproveBtn && client.is_houjin) {
          client.status = 0;
          client.houjin_status = 0;
        }
        this.setState({ processing: false });
        Object.keys(error.response.data.errors).map((key, i) => {
          if ($.isArray(error.response.data.errors[key])) {
            error.response.data.errors[key].map((child, i) => {
              toast.error(child);
            });
          } else {
            toast.error(error.response.data.errors[key]);
          }
        });
      });
  }

  updateAccount(actionFromApproveBtn, client) {
    axios
      .post('/api/accounts/edit/' + client.id, client)
      .then((response) => {
        this.setState({ processing: false });
        if (response.data.success) {
          this.getAccountById();
          toast.success(response.data.message);
        } else {
          if (actionFromApproveBtn && client.is_houjin) {
            client.status = 0;
            client.houjin_status = 0;
          }
          Object.keys(response.data.errors).map((key, i) => {
            if ($.isArray(response.data.errors[key])) {
              response.data.errors[key].map((child, i) => {
                toast.error(child);
              });
            } else {
              toast.error(response.data.errors[key]);
            }
          });
        }
      })
      .catch((error) => {
        if (actionFromApproveBtn && client.is_houjin) {
          client.status = 0;
          client.houjin_status = 0;
        }

        this.setState({ processing: false });
        Object.keys(error.response.data.errors).map((key, i) => {
          if ($.isArray(error.response.data.errors[key])) {
            error.response.data.errors[key].map((child, i) => {
              toast.error(child);
            });
          } else {
            toast.error(error.response.data.errors[key]);
          }
        });
      });
  }

  /**
   * Handle redirect
   */
  handleRedirect(e) {
    e.preventDefault();
    this.props.history.push(e.currentTarget.getAttribute('href'));
  }

  /**
   * Crop image identification file
   */
  cropImageIdentification() {
    if (window.avatarEditorImgIden) {
      const canvas = window.avatarEditorImgIden
        .getImageScaledToCanvas()
        .toDataURL();
      let clientData = Object.assign({}, this.state.client);
      clientData[this.state.imgIdentification.name + '_crop'] = canvas;
      this.setState({ client: clientData });
      $('#img-' + this.state.imgIdentification.name).attr('src', canvas);
      $('#img-identification_img_file').show();
      $('#btn-crop-image-file').removeClass('cls-is-showing');
      $('#identificationCanvas').hide();
    }
  }

  /**
   * Crop image identification file back
   */
  cropImageIdentificationFileBack() {
    if (window.avatarEditorImgIdenFileBack) {
      const canvas = window.avatarEditorImgIdenFileBack
        .getImageScaledToCanvas()
        .toDataURL();
      let clientData = Object.assign({}, this.state.client);
      clientData[this.state.imgIdentificationFileBack.name + '_crop'] = canvas;
      this.setState({ client: clientData });
      $('#img-' + this.state.imgIdentificationFileBack.name).attr(
        'src',
        canvas
      );
      $('#img-identification_img_file_back').show();
      $('#btn-crop-image-file-back').removeClass('cls-is-showing');
      $('#identificationFileBackCanvas').hide();
    }
  }

  /**
   * Crop image identification file back 2
   */
  cropImageIdentificationFileBack2() {
    if (window.avatarEditorImgIdenFileBack2) {
      const canvas = window.avatarEditorImgIdenFileBack2
        .getImageScaledToCanvas()
        .toDataURL();
      let clientData = Object.assign({}, this.state.client);
      clientData[this.state.imgIdentificationFileBack2.name + '_crop'] = canvas;
      this.setState({ client: clientData });
      $('#img-' + this.state.imgIdentificationFileBack2.name).attr(
        'src',
        canvas
      );
      $('#img-identification_img_file_back2').show();
      $('#btn-crop-image-file-back2').removeClass('cls-is-showing');
      $('#identificationFileBack2Canvas').hide();
    }
  }

  /**
   * Handle hover image
   */
  onHoverTooltip() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  renderHoujinStatus() {
    let client = this.getData();
    if (client.is_houjin) {
      return (
        <div className="form-group">
          <label className="form-label" htmlFor="">
            法人ステータス
          </label>
          <ConstElement
            onElementChange={this.handleInptChange}
            element="clients.houjin_status"
            value={this.state.client.houjin_status}
          />
        </div>
      );
    }
    return;
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/home">
                    ダッシュボード
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/accounts">
                    登録者一覧
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  登録者編集
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <main id="main" onMouseOver={this.onHoverTooltip}>
          <div className="row justify-content-md-center">
            <div className="col-sm-9">
              <div className="card mb-3">
                <div className="card-header p-4 border-bottom-0">
                  <h4 className="mb-0">ログイン情報</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          メールアドレス
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "email",
                          value: this.state.client.email || "",
                          className: "form-control",
                        })}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          パスワード
                        </label>
                        {React.createElement("input", {
                          type: "password",
                          onChange: this.handleInptChange,
                          name: "password",
                          className: "form-control",
                        })}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          パスワード確認
                        </label>
                        {React.createElement("input", {
                          type: "password",
                          onChange: this.handleInptChange,
                          name: "password_confirmation",
                          className: "form-control",
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          依頼者ID
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          value: this.state.client.client_id,
                          className: "form-control",
                          disabled: true,
                        })}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          ワーカーID
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          value: this.state.client.staff_id,
                          className: "form-control",
                          disabled: true,
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mb-3">
                <div className="card-header p-4 border-bottom-0">
                  <h4 className="mb-0">面接情報</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          ステータス
                        </label>
                        <input
                          type="text"
                          value={
                            this.state.client.status
                              ? this.processStatus(this.state.client.status)
                              : "未承認"
                          }
                          disabled
                          className="form-control cls-status"
                        />
                      </div>
                      {this.renderHoujinStatus()}
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          面接日
                        </label>
                        <div className="input-group">
                          <DatePicker
                            locale="ja-JP"
                            className="form-control form_datepicker"
                            dateFormat="YYYY/MM/DD"
                            selected={
                              this.state.client.date_interview
                                ? moment(
                                    new Date(this.state.client.date_interview)
                                  )
                                : this.state.client.date_interview
                            }
                            onChange={this.handleChangeEditDateInterview}
                            placeholderText="面接日を選択"
                            disabledKeyboardNavigation
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              id="form-calendar"
                            >
                              <i className="material-icons">calendar_today</i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          面談時間
                        </label>
                        <ConstElement
                          onElementChange={this.handleInptChange}
                          element="time_interview"
                          value={
                            this.state.client.time_interview
                              ? this.state.client.time_interview
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          面談方法
                        </label>
                        <ConstElement
                          onElementChange={this.handleInptChange}
                          element="method_interview"
                          value={
                            this.state.client.method_interview
                              ? this.state.client.method_interview
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          コンタクトID
                        </label>
                        <input
                          type="text"
                          onChange={this.handleInptChange}
                          name="contact_id_interview"
                          value={
                            this.state.client.contact_id_interview
                              ? this.state.client.contact_id_interview
                              : ""
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          否認理由
                        </label>
                        <ConstElement
                          element="reject_reason"
                          onElementChange={this.handleInptChange}
                          value={
                            this.state.client.reject_reason
                              ? this.state.client.reject_reason
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          反社チェック
                        </label>
                        <ConstElement
                          element="anti_check"
                          onElementChange={this.handleInptChange}
                          value={
                            this.state.client.anti_check
                              ? this.state.client.anti_check
                              : ""
                          }
                        />
                        <p className="mt-3">
                          <a
                            href={
                              "https://www.google.co.jp/search?q=" +
                              this.state.client.firstname +
                              this.state.client.lastname
                            }
                            target="_blank"
                            className="text-danger"
                          >
                            <strong>
                              {this.state.client.firstname +
                                this.state.client.lastname}
                              をgoogleでチェックする
                            </strong>
                          </a>
                        </p>
                      </div>
                      {this.state.client.bill_flag
                        ? (
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              SMSオン/オフ
                            </label>
                            <div className="row">
                              <div className="col-12 col-sm-3">
                                <input
                                  onChange={this.handleInptChange}
                                  value="1"
                                  type="radio"
                                  name="sms_enabled"
                                  id="sms_enabled"
                                  checked={
                                    this.state.client.sms_enabled == 1 ||
                                    this.state.client.sms_enabled == null
                                      ? "checked"
                                      : ""
                                  }
                                />
                                <label htmlFor="sms_enabled" className="ml-1">
                                  <p className="h5 font-weight-normal">オン</p>
                                </label>
                              </div>
                              <div className="col-12 col-sm-3">
                                <input
                                  onChange={this.handleInptChange}
                                  value="0"
                                  type="radio"
                                  name="sms_enabled"
                                  id="sms_disabled"
                                  checked={
                                    this.state.client.sms_enabled == 0
                                      ? "checked"
                                      : ""
                                  }
                                />
                                <label htmlFor="sms_disabled" className="ml-1">
                                  <p className="h5 font-weight-normal">オフ</p>
                                </label>
                              </div>
                            </div>
                          </div>
                        ):""
                      }
                    </div>
                    <div className="col-sm-8">
                      <div className="row">
                        <div className="col-sm-4 block-hidden">
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              プロフィール画像
                            </label>
                            {this.state.client.profile_img_file != "no" &&
                            this.state.client.profile_img_file ? (
                              <a
                                data-toggle="tooltip"
                                className="cls-image clickable"
                                title="元画像を見る"
                                url={
                                  this.state.client.id
                                    ? "/api/clients/" +
                                      this.state.client.id +
                                      "/image/profile"
                                    : ""
                                }
                                onClick={this.showImgOriginal}
                              >
                                <img
                                  src={this.state.client.profile_img_file}
                                  id="img-profile_img_file"
                                  className="imagePreview img-thumbnail"
                                />
                              </a>
                            ) : null}
                            {React.createElement("input", {
                              type: "file",
                              onChange: this.handlePreviewImg,
                              name: "profile_img_file",
                              className: "btn w-100",
                            })}
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              本人確認画像 1枚目
                            </label>
                            <br />
                            {this.state.client.identification_img_file !=
                              "no" &&
                            this.state.client.identification_img_file ? (
                              <a
                                data-toggle="tooltip"
                                className="cls-image clickable"
                                title="元画像を見る"
                                url={
                                  this.state.client.id
                                    ? "/api/clients/" +
                                      this.state.client.id +
                                      "/image/identification-file"
                                    : ""
                                }
                                onClick={this.showImgOriginal}
                              >
                                <img
                                  src={
                                    this.state.client.identification_img_file
                                  }
                                  width={this.state.imgIdentification.width}
                                  height={this.state.imgIdentification.height}
                                  id="img-identification_img_file"
                                  className="imagePreview img-thumbnail"
                                />
                              </a>
                            ) : null}
                            {React.createElement("input", {
                              type: "file",
                              accept: ".png, .jpg",
                              onChange: this.handlePreviewImg,
                              name: "identification_img_file",
                              className: "btn w-100",
                              id: "id_identification_img_file",
                            })}
                            <div
                              id="identificationCanvas"
                              className="block-hidden"
                            >
                              <AvatarEditor
                                ref={(avatarEditor) => {
                                  window.avatarEditorImgIden = avatarEditor;
                                }}
                                image={this.state.imgIdentification.img}
                                width={this.state.imgIdentification.width}
                                height={this.state.imgIdentification.height}
                                border={30}
                                color={[51, 51, 51, 0.3]}
                                rotate={0}
                              />
                              <div className="">
                                <div
                                  id="btn-crop-image-file"
                                  className="btn btn-primary"
                                  onClick={this.cropImageIdentification}
                                >
                                  画像をクロップ
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              本人確認画像 2枚目
                            </label>
                            <br />
                            {this.state.client.identification_img_file_back !=
                              "no" &&
                            this.state.client.identification_img_file_back ? (
                              <a
                                data-toggle="tooltip"
                                className="cls-image clickable"
                                title="元画像を見る"
                                url={
                                  this.state.client.id
                                    ? "/api/clients/" +
                                      this.state.client.id +
                                      "/image/identification-file-back"
                                    : ""
                                }
                                onClick={this.showImgOriginal}
                              >
                                <img
                                  src={
                                    this.state.client
                                      .identification_img_file_back
                                  }
                                  width={
                                    this.state.imgIdentificationFileBack.width
                                  }
                                  height={
                                    this.state.imgIdentificationFileBack.height
                                  }
                                  id="img-identification_img_file_back"
                                  className="imagePreview img-thumbnail"
                                />
                              </a>
                            ) : null}
                            {React.createElement("input", {
                              type: "file",
                              accept: ".png, .jpg",
                              onChange: this.handlePreviewImg,
                              name: "identification_img_file_back",
                              className: "btn w-100",
                              id: "id_identification_img_file_back",
                            })}
                            <div
                              id="identificationFileBackCanvas"
                              className="block-hidden"
                            >
                              <AvatarEditor
                                ref={(avatarEditor) => {
                                  window.avatarEditorImgIdenFileBack =
                                    avatarEditor;
                                }}
                                image={this.state.imgIdentificationFileBack.img}
                                width={
                                  this.state.imgIdentificationFileBack.width
                                }
                                height={
                                  this.state.imgIdentificationFileBack.height
                                }
                                border={30}
                                color={[51, 51, 51, 0.3]}
                                rotate={0}
                              />
                              <div className="">
                                <div
                                  id="btn-crop-image-file-back"
                                  className="btn btn-primary"
                                  onClick={this.cropImageIdentificationFileBack}
                                >
                                  画像をクロップ
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              本人確認画像 3枚目
                            </label>
                            <br />
                            {this.state.client.identification_img_file_back2 !=
                              "no" &&
                            this.state.client.identification_img_file_back2 ? (
                              <a
                                data-toggle="tooltip"
                                className="cls-image clickable"
                                title="元画像を見る"
                                url={
                                  this.state.client.id
                                    ? "/api/clients/" +
                                      this.state.client.id +
                                      "/image/identification-file-back2"
                                    : ""
                                }
                                onClick={this.showImgOriginal}
                              >
                                <img
                                  src={
                                    this.state.client
                                      .identification_img_file_back2
                                  }
                                  width={
                                    this.state.imgIdentificationFileBack2.width
                                  }
                                  height={
                                    this.state.imgIdentificationFileBack2.height
                                  }
                                  id="img-identification_img_file_back2"
                                  className="imagePreview img-thumbnail"
                                />
                              </a>
                            ) : null}
                            {React.createElement("input", {
                              type: "file",
                              accept: ".png, .jpg",
                              onChange: this.handlePreviewImg,
                              name: "identification_img_file_back2",
                              className: "btn w-100",
                              id: "id_identification_img_file_back2",
                            })}
                            <div
                              id="identificationFileBack2Canvas"
                              className="block-hidden"
                            >
                              <AvatarEditor
                                ref={(avatarEditor) => {
                                  window.avatarEditorImgIdenFileBack2 =
                                    avatarEditor;
                                }}
                                image={
                                  this.state.imgIdentificationFileBack2.img
                                }
                                width={
                                  this.state.imgIdentificationFileBack2.width
                                }
                                height={
                                  this.state.imgIdentificationFileBack2.height
                                }
                                border={30}
                                color={[51, 51, 51, 0.3]}
                                rotate={0}
                              />
                              <div className="">
                                <div
                                  id="btn-crop-image-file-back2"
                                  className="btn btn-primary"
                                  onClick={
                                    this.cropImageIdentificationFileBack2
                                  }
                                >
                                  画像をクロップ
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              メモ
                            </label>
                            <textarea
                              onChange={this.handleInptChange}
                              name="remark"
                              value={
                                this.state.client.remark
                                  ? this.state.client.remark
                                  : ""
                              }
                              className="form-control"
                              rows="4"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <label className="form-label" htmlFor="">
                              個人認証
                            </label>
                            <ConstElement
                              onElementChange={this.handleInptChange}
                              element="confirmed_at"
                              value={this.state.client.confirmed_at ? 1 : ""}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mb-3">
                <div className="card-header p-4 border-bottom-0">
                  <h4 className="mb-0">個人情報</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          お名前
                        </label>
                        <div className="row">
                          <div className="col-sm-6">
                            {React.createElement("input", {
                              type: "text",
                              onChange: this.handleInptChange,
                              name: "firstname",
                              value: this.state.client.firstname || "",
                              className: "form-control",
                              placeholder: "山田",
                            })}
                          </div>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={this.handleInptChange}
                              name="lastname"
                              value={
                                this.state.client.lastname
                                  ? this.state.client.lastname
                                  : ""
                              }
                              className="form-control"
                              placeholder="太郎"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          お名前（フリガナ）
                        </label>
                        <div className="row">
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={this.handleInptChange}
                              name="hiragana_firstname"
                              value={
                                this.state.client.hiragana_firstname
                                  ? this.state.client.hiragana_firstname
                                  : ""
                              }
                              className="form-control"
                              placeholder="ヤマダ"
                            />
                          </div>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={this.handleInptChange}
                              name="hiragana_lastname"
                              value={
                                this.state.client.hiragana_lastname
                                  ? this.state.client.hiragana_lastname
                                  : ""
                              }
                              className="form-control"
                              placeholder="タロウ"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          ニックネーム
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "nickname",
                          value: this.state.client.nickname || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          ニックネーム（マスク処理前）
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "nickname_without_mask",
                          value: this.state.client.nickname_without_mask || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          電話番号
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "tel",
                          value: this.state.client.tel || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          誕生日
                        </label>
                        <div className="input-group">
                          <DatePicker
                            locale="ja-JP"
                            className="form-control form_datepicker"
                            dateFormat="YYYY/MM/DD"
                            selected={
                              this.state.client.birthday
                                ? moment(new Date(this.state.client.birthday))
                                : this.state.client.birthday
                            }
                            onChange={this.handleChangeBirthday}
                            placeholderText="1990/01/01"
                            disabledKeyboardNavigation
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              id="form-calendar"
                            >
                              <i className="material-icons">calendar_today</i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          性別
                        </label>
                        <ConstElement
                          onElementChange={this.handleInptChange}
                          element="gender"
                          value={
                            this.state.client.gender
                              ? this.state.client.gender
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          経由
                        </label>
                        <select
                          onChange={this.handleInptChange}
                          name="reach_from"
                          value={
                            this.state.client.reach_from
                              ? this.state.client.reach_from
                              : ""
                          }
                          className="myform-select form-control"
                        >
                          <option value="">選択してください</option>
                          {this.state.reach_from_types.map((dataRow, i) => {
                            return (
                              <option key={i} value={dataRow.value}>
                                {dataRow.text}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          郵便番号
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "zip_no",
                          value: this.state.client.zip_no || "",
                          placeholder: "1540001",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          都道府県
                        </label>
                        <select
                          onChange={this.handleInptChange}
                          name="pref"
                          value={
                            this.state.client.pref ? this.state.client.pref : ""
                          }
                          className="myform-select form-control"
                        >
                          <option value="">選択してください</option>
                          {this.state.prefs.map((dataRow, i) => {
                            return (
                              <option key={i} value={dataRow.id}>
                                {dataRow.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          市区
                        </label>
                        <select
                          onChange={this.handleInptChange}
                          name="city"
                          value={
                            this.state.client.city ? this.state.client.city : ""
                          }
                          className="myform-select form-control"
                        >
                          <option value="">選択してください</option>
                          {this.state.cities
                            .filter(
                              (city) => city.pref_id == this.state.client.pref
                            )
                            .map((dataRow, i) => {
                              return (
                                <option key={i} value={dataRow.id}>
                                  {dataRow.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          町名・番地
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "address",
                          value: this.state.client.address || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          ビル・建物名
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "address2",
                          value: this.state.client.address2 || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          ワーカー評価
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "staff_evaluation_avg",
                          value: this.state.client.staff_evaluation_avg || "",
                          className: "form-control",
                        })}
                        <p className="text-left text-danger">
                          ※1~5の整数で入力してください。
                        </p>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          採用後キャンセル
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "cancel_apply_count",
                          value: this.state.client.cancel_apply_count,
                          className: "form-control",
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mb-3">
                <div className="card-header p-4 border-bottom-0">
                  <h4 className="mb-0">法人情報</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          会社名
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_name"
                              value={
                                this.state.client.company_name
                                  ? this.state.client.company_name
                                  : ""
                              }
                              placeholder="シェアジョブ"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          会社名(フリガナ)
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_hiragana_name"
                              value={
                                this.state.client.company_hiragana_name
                                  ? this.state.client.company_hiragana_name
                                  : ""
                              }
                              placeholder="シェアジョブ"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          事業所名
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_office"
                              value={
                                this.state.client.company_office
                                  ? this.state.client.company_office
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          事業部
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_department"
                              value={
                                this.state.client.company_department
                                  ? this.state.client.company_department
                                  : ""
                              }
                              placeholder="人事部"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          役職
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_position"
                              value={
                                this.state.client.company_position
                                  ? this.state.client.company_position
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          担当者名
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_supervisor"
                              value={
                                this.state.client.company_supervisor
                                  ? this.state.client.company_supervisor
                                  : ""
                              }
                              placeholder="山田　太郎"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          電話番号
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "company_tel",
                          value: this.state.client.company_tel || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          FAX番号
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_facsimile"
                              value={
                                this.state.client.company_facsimile
                                  ? this.state.client.company_facsimile
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          メールアドレス
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="email"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="company_email"
                              value={
                                this.state.client.company_email
                                  ? this.state.client.company_email
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          請求フラグ
                        </label>
                        <ConstElement
                          onElementChange={this.handleInptChange}
                          element="clients.bill_flag"
                          value={
                            this.state.client.bill_flag
                              ? this.state.client.bill_flag
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          締日
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="closing_day"
                              value={
                                this.state.client.closing_day
                                  ? this.state.client.closing_day
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          入金サイト
                        </label>
                        <ConstElement
                          onElementChange={this.handleInptChange}
                          element="clients.payment_period"
                          value={
                            this.state.client.payment_period
                              ? this.state.client.payment_period
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          支払日
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="payment_day"
                              value={
                                this.state.client.payment_day
                                  ? this.state.client.payment_day
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          請求書原本着日
                        </label>
                        <ConstElement
                          onElementChange={this.handleInptChange}
                          element="clients.invoice_date"
                          value={
                            this.state.client.invoice_date
                              ? this.state.client.invoice_date
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          郵便番号
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={this.handleInptChange}
                          name="company_zip_no"
                          value={
                            this.state.client.company_zip_no
                              ? this.state.client.company_zip_no
                              : ""
                          }
                          placeholder="1540001"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          都道府県
                        </label>
                        <select
                          onChange={this.handleInptChange}
                          name="company_pref"
                          value={
                            this.state.client.company_pref
                              ? this.state.client.company_pref
                              : ""
                          }
                          className="form-control"
                        >
                          <option value="">選択してください</option>
                          {this.state.prefs.map((dataRow, i) => {
                            return (
                              <option key={i} value={dataRow.id}>
                                {dataRow.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          市区
                        </label>
                        <select
                          onChange={this.handleInptChange}
                          name="company_city"
                          value={
                            this.state.client.company_city
                              ? this.state.client.company_city
                              : ""
                          }
                          className="form-control"
                        >
                          <option value="">選択してください</option>
                          {this.state.cities
                            .filter(
                              (city) =>
                                city.pref_id == this.state.client.company_pref
                            )
                            .map((dataRow, i) => {
                              return (
                                <option key={i} value={dataRow.id}>
                                  {dataRow.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          町名番地
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "company_address",
                          value: this.state.client.company_address || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          ビル・建物名
                        </label>
                        {React.createElement("input", {
                          type: "text",
                          onChange: this.handleInptChange,
                          name: "company_address2",
                          value: this.state.client.company_address2 || "",
                          className: "form-control",
                        })}
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          募集予定エリア
                        </label>
                        <select
                          onChange={this.handleInptChange}
                          name="recruit_location"
                          value={
                            this.state.client.recruit_location
                              ? this.state.client.recruit_location
                              : ""
                          }
                          className="form-control"
                        >
                          <option value="NULL">選択してください</option>
                          {this.state.prefs.map((dataRow, i) => {
                            return (
                              <option key={i} value={dataRow.id}>
                                {dataRow.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          利用開始予定日
                        </label>
                        <div className="input-group">
                          <DatePicker
                            locale="ja-JP"
                            className="form-control form_datepicker"
                            dateFormat="YYYY/MM/DD"
                            selected={
                              this.state.client.start_date
                                ? moment(new Date(this.state.client.start_date))
                                : this.state.client.start_date
                            }
                            onChange={this.handleChangeStartDate}
                            placeholderText="1990/01/01"
                            disabledKeyboardNavigation
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              id="form-calendar"
                            >
                              <i className="material-icons">calendar_today</i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          シェアジョブをどこで知りましたか？
                        </label>
                        <ConstElement
                          onElementChange={this.handleInptChange}
                          element="clients.regist_reason"
                          value={
                            this.state.client.regist_reason
                              ? this.state.client.regist_reason
                              : ""
                          }
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          システム利用料(%)
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="system_fee_per"
                              value={
                                this.state.client.system_fee_per != null
                                  ? this.state.client.system_fee_per
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          申し込みURL（サイト外）
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="external_apply_url"
                              value={
                                this.state.client.external_apply_url
                                  ? this.state.client.external_apply_url
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <p className="text-left text-danger">
                          ※入力すると「このお仕事に応募する」のリンク先が入力内容のURLに変更されます。
                        </p>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          報酬金額（フリーテキスト）
                        </label>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.handleInptChange}
                              name="free_text_staff_price"
                              value={
                                this.state.client.free_text_staff_price
                                  ? this.state.client.free_text_staff_price
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <p className="text-left text-danger">
                          ※入力すると「報酬金額」がフリーテキストになります。
                        </p>
                      </div>
                      <div className="form-group">
                        <label className="form-label" htmlFor="">
                          その他
                        </label>
                        <textarea
                          onChange={this.handleInptChange}
                          name="company_remark"
                          value={
                            this.state.client.company_remark
                              ? this.state.client.company_remark
                              : ""
                          }
                          className="form-control"
                          rows="5"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-5">
                <div className="col-sm-12">
                  <div className="card-footer">
                    <div className="text-center">
                      <button
                        onClick={() => {
                          this.saveData();
                        }}
                        disabled={this.state.processing}
                        className="btn btn-primary btn-radius btn-lg btn-space"
                      >
                        <span className="size-inherit">保存する</span>
                      </button>
                      {this.state.client.status == 1 ? (
                        <button
                          onClick={this.updateStatus}
                          status="8"
                          disabled={this.state.processing}
                          className="btn bg-pink text-white btn-radius btn-lg"
                        >
                          <span className="size-inherit">アカウント停止</span>
                        </button>
                      ) : (
                        ""
                      )}
                      {this.state.client.status == 8 ? (
                        <button
                          onClick={this.updateStatusRecoverAccount}
                          status="1"
                          disabled={this.state.processing}
                          className="btn bg-pink text-white btn-radius btn-lg"
                        >
                          <span className="size-inherit">アカウント復旧</span>
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {this.state.client.status == 0 ||
              this.state.client.status == null ? (
                <div
                  className={`row footer-status block-hidden-important ${
                    this.state.client.status == 0 || this.state.client.status
                      ? "block-display-important"
                      : ""
                  }`}
                >
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-12 text-center">
                        <p>この依頼者を承認しますか？</p>
                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <button
                              onClick={this.updateStatus}
                              status="1"
                              disabled={this.state.processing}
                              className="btn btn-primary btn-radius"
                            >
                              <span className="size-inherit">承認する</span>
                            </button>
                          </li>
                          <li className="list-inline-item">
                            <button
                              onClick={this.updateStatus}
                              status="9"
                              disabled={this.state.processing}
                              className="btn btn-default btn-radius"
                            >
                              <span className="size-inherit">非承認にする</span>
                            </button>
                          </li>
                          <li className="list-inline-item">
                            <button
                              onClick={this.deleteAccount}
                              disabled={this.state.processing}
                              className="btn bg-pink text-white btn-radius"
                            >
                              <span className="size-inherit">
                                アカウント削除
                              </span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </main>
        <ToastContainer />
      </React.Fragment>
    );
  }
}
